export default "__VITE_ASSET__3dE8vaaj__"